import { IApplicationState } from 'shared/types/redux';

export const selectActionUrl = (state: IApplicationState) => state.landing.actionUrl;
